/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetZReport200Response,
} from '../models/index';
import {
    GetZReport200ResponseFromJSON,
    GetZReport200ResponseToJSON,
} from '../models/index';

export interface GetZReportRequest {
    startDate?: string;
    endDate?: string;
}

/**
 * 
 */
export class ReportsApi extends runtime.BaseAPI {

    /**
     */
    async getZReportRaw(requestParameters: GetZReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetZReport200Response>> {
        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/z`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetZReport200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getZReport(requestParameters: GetZReportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetZReport200Response> {
        const response = await this.getZReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
